/* global process */
//Global constants in this file

// export const HOME_PAGE = process.env.PUBLIC_URL;
export const HOME_PAGE = "";

export const ASQI_COLOR = "#0e4476";
//Dev
// var _SERVER_BASE_ADDRESS = 'http://localhost:8002';
var _SERVER_BASE_ADDRESS = "http://localhost:8000";
// var _SERVER_BASE_ADDRESS = 'https://asqisys.com/backend';
var _GOOGLE_OAUTH_CLIENT_ID =
  "978566420462-jsrnp54ovfn94q05551b3ge73q413h6m.apps.googleusercontent.com";
var _RZP_KEY = "rzp_test_lIPFFCrCh8ljm1";
var _GOOGLE_MAPS_API_KEY = "AIzaSyBirStKK3UUoCRulbaKc1TawwSnuML1ips";
var _WEATHER_API_KEY = "6ae04d9f80d0462eb30102152231406";
var _WEB_PAGE_TO_PDF_API_KEY = "a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6";
var _DEHAAT_LOGIN_URL = "https://kisan-app.dehat.co/api/external/login";

let _NEWRL_PAY_SERVICE = "http://127.0.0.1:8000";
if (process.env.REACT_APP_ENV === "stage") {
  _SERVER_BASE_ADDRESS = "https://api-stage.farmapp.in";
} else if (process.env.NODE_ENV === "production") {
  // Prod
  _SERVER_BASE_ADDRESS = "https://api.farmapp.in";
  // _SERVER_BASE_ADDRESS = '/staging-backend';
  _GOOGLE_OAUTH_CLIENT_ID =
    "978566420462-6g0ase60jqiqnta03q6aaoirnovk2e52.apps.googleusercontent.com";
  _RZP_KEY = "rzp_live_SvgK1UWUY0ad5q";

  _NEWRL_PAY_SERVICE = "https://newrl-pay-api.newrl.net";
} else if (process.env.REACT_APP_ENV === "demo") {
  _SERVER_BASE_ADDRESS = "https://farmtrace-api-demo.newrl.net";
}

// _SERVER_BASE_ADDRESS = 'https://asqisys.com/retail-backend';

export const SERVER_BASE_ADDRESS = _SERVER_BASE_ADDRESS;
export const GOOGLE_OAUTH_CLIENT_ID = _GOOGLE_OAUTH_CLIENT_ID;
export const RZP_KEY = _RZP_KEY;
export const GOOGLE_MAPS_API_KEY = _GOOGLE_MAPS_API_KEY;
export const WEATHER_API_KEY = _WEATHER_API_KEY;
export const WEB_PAGE_TO_PDF_API_KEY = _WEB_PAGE_TO_PDF_API_KEY;
export const DEHAAT_LOGIN_URL = _DEHAAT_LOGIN_URL;

// export const getBlockchainNodeUrl() = 'https://devnetapi.newrl.net';
// export let getBlockchainNodeUrl() = 'http://archive1-mainnet.newrl.net:8456';

export const NEWRL_PAY_SERVICE = _NEWRL_PAY_SERVICE;
export const FAUCET_URL =
  "https://gsd8hwxzw9.execute-api.ap-south-1.amazonaws.com/default/NWRLFaucet";
// export const NEWRL_PAY_SERVICE = 'http://127.0.0.1:8000'

export const NWRL_DECIMAL_MULTIPLIER = 1000000;
// export const getBlockchainPort() = 8421;
// export const NWRL_SCAN_BACKEND = 'https://newrl-testnet-scan-backend.herokuapp.com'

export const changeBlockChain = (chain) => {
  if (chain === "Mainnet") {
    // getBlockchainNodeUrl() = 'http://archive1-mainnet.newrl.net:8456';
    localStorage.setItem("blockchain", "Mainnet");
  } else {
    // getBlockchainNodeUrl() = 'https://devnetapi.newrl.net';
    localStorage.setItem("blockchain", "Testnet");
  }
  // window.location.reload()
};

export const BLOCKCHAINS = {
  Mainnet: {
    node: "https://mainnetgw.newrl.net",
    scanner: "https://newrl-mainnet-scan-backend.herokuapp.com",
    port: 8456,
  },
  Testnet: {
    // node: 'https://devnetapi.newrl.net',
    // scanner: 'https://newrl-testnet-scan-backend.herokuapp.com',
    node: "https://lakeshore-testnetgw.newrl.net",
    scanner: "https://newrl-lakeshore-test-backend.herokuapp.com",
    port: 8421,
  },
  Local: {
    // node: 'http://54.161.8.218:4018'
    node: "https://lakeshore-testnetgw.newrl.net",
    scanner: "https://newrl-lakeshore-test-backend.herokuapp.com",
    port: 8421,
  },
};

const DEFAULT_NETWORK = "Testnet";

export const getBlockchainNodeUrl = () => {
  let chain = localStorage.getItem("blockchain");
  if (!chain || chain === null) {
    chain = DEFAULT_NETWORK;
    localStorage.setItem("blockchain", DEFAULT_NETWORK);
  }

  return BLOCKCHAINS[chain]["node"];
};

export const getBlockchain = () => {
  let chain = localStorage.getItem("blockchain");
  if (!chain || chain === null) {
    chain = DEFAULT_NETWORK;
    localStorage.setItem("blockchain", DEFAULT_NETWORK);
  }
  return chain;
};

export const getBlockchainPort = () => {
  let chain = localStorage.getItem("blockchain");
  if (!chain || chain === null) {
    chain = DEFAULT_NETWORK;
    localStorage.setItem("blockchain", DEFAULT_NETWORK);
  }

  return BLOCKCHAINS[chain]["port"];
};

export const getBlockchainScanner = () => {
  let chain = localStorage.getItem("blockchain");
  if (!chain || chain === null) {
    chain = DEFAULT_NETWORK;
    localStorage.setItem("blockchain", DEFAULT_NETWORK);
  }

  return BLOCKCHAINS[chain]["scanner"];
};

export const getTransactionToSignFromLocal = () => {
  let txn = localStorage.getItem("transactionToSign");
  try {
    return txn;
  } catch {
    return "";
  }
};

export const formatToIndianTime = (utcDateString) => {
  const date = new Date(utcDateString);
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "Asia/Kolkata", // Convert to Indian Standard Time (IST)
  };
  return new Intl.DateTimeFormat("en-US", options).format(date);
};

export const NUSDC_TOKEN_CODE = "NUSDC";
export const OTC_FEE_PAYER = "0x3f6f782be887b1e565028d5d53d8c79c9222b745";
export const DECIMAL_ROUND = 3;

export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const AGRI_COMMODITY_TYPE_CONVENTION = 93;
export const FARMLAND_TOKEN_TYPE_CONVENTION = 76;
export const CROP_TOKEN_TYPE_CONVENTION = 77;
export const CC_TOKEN_TYPE_CONVENTION = 100;
export const PROCESSING_PLANT_TYPE_CONVENTION = 74;
export const WAREHOUSE_TYPE_CONVENTION = 75;
export const STORAGE_TYPE_CONVENTION = 81;
export const PRODUCT_TYPE_CONVENTION = 92;
export const TRANSPORT_TYPE_CONVENTION = 10;
export const FARMAPP_TAG_LINE = "तकनिक से तरक्की";
export const ACRES_TO_HECTARES_RATIO = 0.404686;
